import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5938 3.75C15.0526 3.75 15.4532 4.06265 15.5645 4.50781L16.5 8.25H19C20.1046 8.25 21 9.14543 21 10.25V18.25C21 19.3546 20.1046 20.25 19 20.25H5C3.89543 20.25 3 19.3546 3 18.25V10.25C3 9.14543 3.89543 8.25 5 8.25H7.5L8.43555 4.50781C8.54684 4.06265 8.94738 3.75 9.40625 3.75H14.5938ZM12 9.75C9.92893 9.75 8.25 11.4289 8.25 13.5C8.25 15.5711 9.92893 17.25 12 17.25C14.0711 17.25 15.75 15.5711 15.75 13.5C15.75 11.4289 14.0711 9.75 12 9.75Z",
		fill: "currentColor"
	})
});
export default SvgCamera;
